import { data } from '../../svg/Toggle/data';
import { makeIcon } from '../makeIcon';

export const Toggle = makeIcon(data, 'toggle', 'Toggle');

export default Toggle;
